import { render, staticRenderFns } from "./RegisterElement.vue?vue&type=template&id=ed963ad8&scoped=true&"
import script from "./RegisterElement.vue?vue&type=script&lang=js&"
export * from "./RegisterElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed963ad8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OtpInput: require('/www/togihome-buyer/components/otp/OtpInput.vue').default})
